import React from 'react';
import { Award, Users, TrendingUp, CheckCircle } from 'lucide-react';

export const About = () => {
  const stats = [
    { icon: Users, label: 'Happy Clients', value: '150+' },
    { icon: Award, label: 'Certifications', value: '25+' },
    { icon: TrendingUp, label: 'Success Rate', value: '98%' },
  ];

  const values = [
    {
      title: 'Expertise You Can Trust',
      description: 'Our team holds top-tier certifications from AWS, Azure, and industry-leading DevOps platforms. We stay ahead of the curve to deliver cutting-edge solutions.'
    },
    {
      title: 'Tailored Solutions',
      description: 'No two businesses are alike. We take the time to understand your unique challenges and craft customized solutions that align with your goals.'
    },
    {
      title: 'Proven Track Record',
      description: 'With hundreds of successful projects across various industries, we have the experience and knowledge to handle projects of any scale and complexity.'
    },
    {
      title: 'Global Availability',
      description: 'Available on Upwork for seamless collaboration. We work with clients worldwide, delivering excellence regardless of location or timezone.'
    }
  ];

  return (
    <section id="about" className="py-20 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Why Choose Us
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We're not just another IT services provider. We're your strategic partner in digital transformation, committed to delivering solutions that drive real business value.
            </p>
            <p className="text-gray-600 mb-8 leading-relaxed">
              With deep expertise in cloud infrastructure, DevOps automation, and modern development practices, we help organizations modernize their IT environments and accelerate innovation. Our team of certified professionals brings years of hands-on experience across diverse industries and technologies.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-6">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-blue-50 to-gray-50 p-8 rounded-xl border border-gray-200 text-center hover:shadow-lg transition-shadow"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
                  <stat.icon className="text-white" size={28} />
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {values.map((value, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <CheckCircle className="text-blue-600" size={24} />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};